export const CAIRO_GOVERNORATE = 'القاهرة';
export const GIZA_GOVERNORATE = 'الجيزة';
export const ALEX_GOVERNORATE = 'الإسكندرية';

export const cairoAreas = [
    'مصر الجديدة',
    'مدينة نصر',
    'التجمع',
    'الرحاب / مدينتي',
    'الشروق / بدر',
    'وسط البلد',
    'المعادي',
    'زهراء المعادي',
    'المقطم',
    'حلوان',
    '15 مايو',
    'شبرا',
    'حدائق القبة',
    'الزيتون',
    'عين شمس',
    'المطرية',
    'المرج / السلام',
    'السيدة زينب',
    'مصر القديمة',
];

export const gizaAreas = [
    'المهندسين',
    'الدقي',
    'العجوزة',
    'الزمالك',
    'إمبابة',
    'الوراق',
    'الهرم',
    'فيصل',
    'الجيزة',
    'العمرانية',
    'الطالبية',
    'بولاق الدكرور',
    'حدائق الأهرام',
    '6 أكتوبر',
    'الشيخ زايد',
    'حدائق أكتوبر',
    'نيو جيزة',
];

export const alexAreas = [
    'الإسكندرية',
    'ميامي',
    'سيدي بشر',
    'المندرة',
    'أبو قير',
    'إدكو',
    'الساعة',
    'باكوس',
    'العوايد',
    'حجر النواتية',
    'سموحة',
    'سيدي جابر',
    'محرم بك',
    'الحضرة',
    'الهانوفيل',
    'البيطاش',
];

export const governoratesItems = [
    'القاهرة',
    'الجيزة',
    'الإسكندرية',
    'الإسماعيلية',
    'أسوان',
    'أسيوط',
    'الأقصر',
    'البحر الأحمر',
    'البحيرة',
    'بني سويف',
    'بورسعيد',
    'الدقهلية',
    'دمياط',
    'سوهاج',
    'السويس',
    'الشرقية',
    'الغربية',
    'الفيوم',
    'القليوبية',
    'قنا',
    'كفر الشيخ',
    'مطروح',
    'المنوفية',
    'المنيا',
    'الوادي  الجديد',
    'شمال  سيناء',
    'جنوب سيناء',
];

export function isSelectableAreaGovernorate(governorate) {
    return (
        governorate === CAIRO_GOVERNORATE ||
        governorate === GIZA_GOVERNORATE ||
        governorate === ALEX_GOVERNORATE
    );
}

export function getAreasForGovernorate(governorate) {
    if (governorate === CAIRO_GOVERNORATE) {
        return cairoAreas;
    }
    if (governorate === GIZA_GOVERNORATE) {
        return gizaAreas;
    }
    if (governorate === ALEX_GOVERNORATE) {
        return alexAreas;
    }
    return governorate ? [governorate] : [];
}

export function resolveAreaForGovernorate(governorate, currentArea = '') {
    if (!governorate) {
        return '';
    }
    if (!isSelectableAreaGovernorate(governorate)) {
        return governorate;
    }
    const areas = getAreasForGovernorate(governorate);
    return areas.includes(currentArea) ? currentArea : '';
}
